{
  "aws_project_region": "eu-west-1",
  "aws_appsync_graphqlEndpoint": "https://5dnnzslwbbarxdo3cxuu5oqhb4.appsync-api.eu-west-1.amazonaws.com/graphql",
  "aws_appsync_region": "eu-west-1",
  "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
  "aws_appsync_apiKey": "da2-grwkazdinraxfeg4hoh3mzpggm",
  "aws_cognito_identity_pool_id": "eu-west-1:9cdd4e37-de38-4775-bf9f-2e90d617a454",
  "aws_cognito_region": "eu-west-1",
  "aws_user_pools_id": "eu-west-1_6WZ3pTOJe",
  "aws_user_pools_web_client_id": "4ihe4dbodqc28muig30boovden",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL",
    "FAMILY_NAME",
    "GIVEN_NAME"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "sesiodf72c19c9c644d01a01fb08f7664421e150039-production",
  "aws_user_files_s3_bucket_region": "eu-west-1",
  "geo": {
    "amazon_location_service": {
      "region": "eu-west-1",
      "search_indices": {
        "items": [
          "geocode-production"
        ],
        "default": "geocode-production"
      }
    }
  }
}